import {
  defaultDropoffFeeUsd,
  DropoffProviderType,
  getMerchantFacingProviderName,
} from "@redotech/redo-return-dropoff-provider-common/dropoff-provider";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { groupInput, input, InputSchema, listInput } from "@redotech/ui/form";
import { memo } from "react";

const feeValidator = (value: string) => {
  const num = Number(value);
  if (isNaN(num)) {
    return ["Must be a valid number"];
  }
  if (num <= 0) {
    return ["Must be greater than 0"];
  }
  return [];
};

export const boxlessDropoffsForm = listInput(
  () =>
    groupInput({
      provider: input<DropoffProviderType>(),
      fee: input<string>({ validator: feeValidator }),
    }),
  (provider: DropoffProviderType) => ({
    provider,
    fee: String(defaultDropoffFeeUsd[provider] ?? 0),
  }),
  (value) => value.provider,
);

export type BoxlessDropoffsForm = InputSchema.Input<typeof boxlessDropoffsForm>;
export type BoxlessDropoffsValue = InputSchema.Value<
  typeof boxlessDropoffsForm
>;

export const BoxlessDropoffsSettings = memo(function BoxlessDropoffsSettings({
  input,
}: {
  input: BoxlessDropoffsForm;
}) {
  return (
    <Flex justify="flex-start" w="full">
      <Flex flexDirection="column" gap="3xl" w="half">
        {input.inputs.map((feeInput) => {
          const providerName = getMerchantFacingProviderName(
            feeInput.value.provider,
          );
          return (
            <Card key={feeInput.value.provider} title={providerName}>
              <Flex>
                <RedoTextInput
                  description={`The amount Redo charges the merchant per ${providerName} drop-off`}
                  errorText={feeInput.inputs.fee.errors[0]}
                  IconTrailing={() => (
                    <Text fontSize="xs" textColor="secondary">
                      USD
                    </Text>
                  )}
                  inputTypeHint="number"
                  label="Drop-off fee"
                  min={0}
                  setValue={feeInput.inputs.fee.setValue}
                  step={0.01}
                  value={feeInput.inputs.fee.value}
                />
              </Flex>
            </Card>
          );
        })}
      </Flex>
    </Flex>
  );
});
